export const FETCH_SCENARIO_INFORMATION = 'FETCH_SCENARIO_INFORMATION';
